export default "__VITE_ASSET__eb73d68d__"